import type { WorkShiftCell } from "@senciamatch/shared/models/workShiftCell";
import { useNavigate } from "react-router-dom";

interface Props {
  workShiftCells: WorkShiftCell[];
}

const CellNull = () => {
  return (
    <td className="border border-gray-100 w-[270px] h-[80px]">
      <div className="flex items-center justify-center h-full w-[270px]">
        <div className="text-gray-500">-</div>
      </div>
    </td>
  );
};

export const Cell = (props: Props) => {
  const { workShiftCells } = props;
  const navigate = useNavigate();

  if (!workShiftCells || workShiftCells.length === 0) return <CellNull />;

  // If there's only one shift, display it as before
  if (workShiftCells.length === 1) {
    const workShiftCell = workShiftCells[0];
    const handleClick = () => {
      navigate(`/matchings/${workShiftCell.workShiftId}/modify`);
    };

    return (
      <td className="border border-gray-100 w-[270px] h-[80px]">
        <div
          className="flex flex-col items-center justify-center h-full w-[270px] relative cursor-pointer hover:bg-gray-50"
          onClick={handleClick}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleClick();
          }}
        >
          <div className="absolute top-2 left-2">
            {workShiftCell.status === "Confirmed" && <img src="/icons/confirmed.svg" alt="confirmed" />}
            {workShiftCell.status === "NotConfirmed" && <img src="/icons/not_confirmed.svg" alt="not confirmed" />}
          </div>
          <p className="text-center">{workShiftCell.staffName}</p>
          <p className="text-center">
            {workShiftCell.shiftSymbol}({String(workShiftCell.startHour).padStart(2, "0")}:
            {String(workShiftCell.startMinute).padStart(2, "0")} - {String(workShiftCell.endHour).padStart(2, "0")}:
            {String(workShiftCell.endMinute).padStart(2, "0")})
          </p>
          {workShiftCell.isFirstShift && <p className="text-blue-500">初担当</p>}
        </div>
      </td>
    );
  }

  // Multiple shifts in the same day
  return (
    <td className="border border-gray-100 w-[270px]">
      <div className="flex flex-col divide-y divide-gray-200">
        {workShiftCells.map((workShiftCell) => {
          const handleClick = () => {
            navigate(`/matchings/${workShiftCell.workShiftId}/modify`);
          };

          return (
            <div
              key={workShiftCell.workShiftId}
              className="flex flex-col items-center justify-center p-2 relative cursor-pointer hover:bg-gray-50"
              onClick={handleClick}
              onKeyDown={(e) => {
                if (e.key === "Enter") handleClick();
              }}
            >
              <div className="absolute top-1 left-1">
                {workShiftCell.status === "Confirmed" && (
                  <img src="/icons/confirmed.svg" alt="confirmed" className="w-4 h-4" />
                )}
                {workShiftCell.status === "NotConfirmed" && (
                  <img src="/icons/not_confirmed.svg" alt="not confirmed" className="w-4 h-4" />
                )}
              </div>
              <p className="text-sm text-center">{workShiftCell.staffName}</p>
              <p className="text-xs text-center">
                {workShiftCell.shiftSymbol}({String(workShiftCell.startHour).padStart(2, "0")}:
                {String(workShiftCell.startMinute).padStart(2, "0")} - {String(workShiftCell.endHour).padStart(2, "0")}:
                {String(workShiftCell.endMinute).padStart(2, "0")})
              </p>
              {workShiftCell.isFirstShift && <p className="text-xs text-blue-500">初担当</p>}
            </div>
          );
        })}
      </div>
    </td>
  );
};
